/* istanbul ignore file: Directive */
'use strict';

/**
 * Check if value is a correct formatted vat number.
 * Converts to the recent format if the old one is given.
 */
customerZone.directive('validateVat', ['utils', function(utils){
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ctrl){
            ctrl.$parsers.push(function(value){
                if (value === '') return '';
                else {
                    var valid = utils.checkVat(value);
                    if (!valid.valid) return undefined;
                    return valid.normalized;
                }
            });
        }
    };
}]);
